/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var ProductHeader;
(function (ProductHeader) {
    var publicationStatus;
    (function (publicationStatus) {
        publicationStatus["P"] = "P";
        publicationStatus["S"] = "S";
    })(publicationStatus = ProductHeader.publicationStatus || (ProductHeader.publicationStatus = {}));
    /**
     * indicates if product is visible in visualization tool menu
     */
    var cetVisibleIndicator;
    (function (cetVisibleIndicator) {
        cetVisibleIndicator["Y"] = "Y";
        cetVisibleIndicator["N"] = "N";
    })(cetVisibleIndicator = ProductHeader.cetVisibleIndicator || (ProductHeader.cetVisibleIndicator = {}));
})(ProductHeader || (ProductHeader = {}));
